export const offerPurchaseMethods = {
  WALK: "WALK",
  CLICK: "CLICK",
  CALL: "CALL",
};
